import React from 'react';
import { MODAL_STYLES } from '../../utils/modalStyles';

/**
 * Standardized form container for modal content
 * Provides consistent spacing and layout for form elements
 *
 * @param {React.ReactNode} children - Form elements to display
 * @param {object} style - Additional custom styles (optional)
 * @param {string} gap - Custom gap between form elements (default: '16px')
 */
export default function ModalFormContainer({
  children,
  style = {},
  gap = '16px'
}) {
  const containerStyle = {
    ...MODAL_STYLES.formContainer,
    gap,
    ...style,
  };

  return (
    <div style={containerStyle}>
      {children}
    </div>
  );
}